import {TableHtml} from "./TableHtml.js";

export class TableCmp {
    /** @type {TableHtml} */
    #html;

    constructor() {
        this.#html = new TableHtml();
    }

    /** @param {HTMLElement} parentEl */
    init(parentEl) {
        this.#html.init(parentEl);
    }

    show() {
        this.#html.show();
    }

    /** @param {MoleculeEvent[]}rows */
    loadFirstPage(rows) {
        this.#html.clearRows();
        this.#html.addRows(rows);
    }

    /** @param {MoleculeEvent[]}rows */
    loadNextPage(rows) {
        this.#html.addRows(rows);
    }
}